import { ActionType } from '../ActionTypes';
import { StoreAction, store } from '../Store';
import { ReferralState } from './ReferralState';

export type ReferralAction = {
  type: ActionType.SET_REFERRAL_INFO;
  referralInfo: Partial<ReferralState>;
};

export function referralReducer(state: ReferralState, action: StoreAction): ReferralState {
  switch (action.type) {
    case ActionType.SET_REFERRAL_INFO: {
      return { ...state, ...action.referralInfo };
    }
    default:
      return state;
  }
}

export function dispatchReferralInfo(referralInfo: Partial<ReferralState>): void {
  store.dispatch({ type: ActionType.SET_REFERRAL_INFO, referralInfo });
}
